import React, { useEffect, useState } from 'react';
import ActivitiesFilter from '../components/activities/ActivitiesFilter';
import ActivitiesList from '../components/activities/ActivitiesList';
import { useWeb3 } from '../contexts/Web3Context';
import { useUI } from '../contexts/UIContext';

const Activities = () => {
  const { userId, grichInvContract, isConnected } = useWeb3();
  const { activitiesPage, setActivitiesPage, totalActivitiesPages, setTotalActivitiesPages, activityType, setActivityType, showLoading, hideLoading, showModal } = useUI();
  const [activities, setActivities] = useState([]);

  // Load activities when page changes
  useEffect(() => {
    if (userId > 0 && grichInvContract) {
      loadActivities();
    }
  }, [userId, grichInvContract, activitiesPage, activityType]);

  const loadActivities = async () => {
    try {
      showLoading('Loading activities...');
      
      // Get activities length for pagination
      const activitiesLength = await grichInvContract.getUserActivitiesLength(userId);
      const activitiesPerPage = 10;
      const totalPages = Math.ceil(activitiesLength / activitiesPerPage);
      setTotalActivitiesPages(totalPages === 0 ? 1 : totalPages);
      
      // Get activities
      const activitiesResponse = await grichInvContract.getRecentActivities(userId, activitiesPage);
      
      // Filter activities by type if specified
      const filteredActivities = activityType === 'all' 
        ? activitiesResponse 
        : activitiesResponse.filter(activity => activity.mode.toString() === activityType);
      
      // Reverse to show newest first
      const reversedActivities = [...filteredActivities].reverse();
      
      setActivities(reversedActivities);
      hideLoading();
    } catch (error) {
      console.error('Error loading activities:', error);
      hideLoading();
      showModal('Error', 'Failed to load activities. Please try again.');
    }
  };

  // If not connected or no user ID, show message
  if (!isConnected || !userId || userId === 0) {
    return (
      <>
        <h1>Your <span className="highlight">Activities</span></h1>
        <p className="section-description">Track all your investments, earnings and rewards</p>
        
        <div className="not-connected-message" style={{ 
          textAlign: 'center', 
          background: 'var(--bg-card)', 
          padding: '50px 20px',
          borderRadius: '15px',
          margin: '40px 0'
        }}>
          <h2>{isConnected ? 'Make Your First Investment' : 'Connect Your Wallet'}</h2>
          <p style={{ marginTop: '15px', color: 'var(--text-muted)' }}>
            {isConnected 
              ? 'You need to make your first investment to see your activities.'
              : 'Connect your wallet to view your activities.'}
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <h1>Your <span className="highlight">Activities</span></h1>
      <p className="section-description">Track all your investments, earnings and rewards</p>
      
      {/* Activities Filter */}
      <ActivitiesFilter 
        activityType={activityType}
        onTypeChange={(type) => {
          setActivityType(type);
          setActivitiesPage(1); // Reset to first page when filter changes
        }}
      />
      
      {/* Activities List */}
      <ActivitiesList 
        activities={activities}
        currentPage={activitiesPage}
        totalPages={totalActivitiesPages}
        onPageChange={setActivitiesPage}
      />
    </>
  );
};

export default Activities;
